// extracted by mini-css-extract-plugin
export default {"textInput":"EntityInputs_textInput__MZEDB"};